import React from 'react'
import '../../App.css'
import Footer from '../Footer'
import ProductsPage from '../ProductsPage'

function Products() {
    return (
        <>
          <ProductsPage/>
          <Footer/> 
        </>
    )
}


export default Products 

/* Section con id='encargos'
link to='/products/#encargos' */